import clsx from 'clsx';

type ToggleTourTypeOptionProps = {
  active: boolean;
} & React.ComponentPropsWithoutRef<'button'>;

export function ToggleTourTypeOption(props: ToggleTourTypeOptionProps) {
  const { className, active, ...otherProps } = props;

  return (
    <button
      {...otherProps}
      type="button"
      className={clsx(
        className,
        'w-[200px] text-teal-40 border border-grey-90 rounded-full py-2 mr-3 mb-2 max-sm:w-[160px]',
        active && 'border-2 border-teal-40'
      )}
    />
  );
}
